import { NotificationState } from "@core/data";

export class NotificationsStateChangedMessage{
    public notificationState: NotificationState;

    constructor(notificationState: NotificationState) {
        this.notificationState = notificationState;
    }
}